<template>
    <div class="com-codics-book-admin-feedback-body">
        <div class="com-codics-book-admin-feedback-bar-content">
            <el-select class="com-codics-book-admin-feedback-bar-pick" v-model="nowState" placeholder="请选择状态" clearable
                @change="listCustomersFuc">
                <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-input class="com-codics-book-admin-feedback-bar-input" style="float: left;" v-model="searchTxt" placeholder="输入关键词进行搜索..."
                clearable @input="searchChange" @change="handleSearchChange">
            </el-input>
            <MyButton style="float: left;margin-left: 15px;padding:0 15px;" @click.native="listCustomersFuc">&#xe86e;
            </MyButton>
            <MyButton id="addCustomerBtn" style="float: right;" @click.native="addVisible = true;">&#xe632; 新建客户
            </MyButton>
            <MyButton style="float: right;margin-right: 15px;" @click.native="exportToExcel" :disabled="selectData.length === 0">
                &#xED60; 导出选中
            </MyButton>
            <MyButton class="iconfonts" style="float: right;margin-right: 15px;" @click.native="handleCheckClick();"
                v-html="editState ? '&#xEB98; 取消编辑' : '&#xF597; 批量编辑'">
            </MyButton>
            <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info" icon-color="red"
                title="您确定要删除选中的客户吗？" @confirm="deleteCustomersFuc">
                <MyButton v-show="editState" style="float: right;margin-right: 15px;" slot="reference">&#xe850; 批量删除
                </MyButton>
            </el-popconfirm>
            <MyButton v-show="editState" style="float: right;margin-right: 15px;" @click.native="checkAll">
                &#xEB79; 全部选中</MyButton>
        </div>
        <div class="com-codics-book-admin-feedback-bar-content com-codics-book-admin-feedback-bar-content2"
            style="margin-top: 10px;">
            <el-table :data="searchTxt ? searchData : tableData" style="width: 100%" v-loading="loading"
                @selection-change="handleSelectionChange" ref="table">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="id" label="ID" width="60"></el-table-column>
                <el-table-column prop="surname" label="姓" width="80"></el-table-column>
                <el-table-column prop="name" label="名" width="80"></el-table-column>
                <el-table-column prop="email" label="邮箱" width="180"></el-table-column>
                <el-table-column prop="phone" label="电话" width="130"></el-table-column>
                <el-table-column prop="company" label="公司" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="pos" label="职位" width="100"></el-table-column>
                <el-table-column prop="type" label="类型" width="100"></el-table-column>
                <el-table-column prop="area" label="地域" width="100"></el-table-column>
                <el-table-column prop="mess" label="内容" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="state" label="状态" width="80">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.state === 0 ? 'warning' : 'success'">
                            {{ scope.row.state === 0 ? '未处理' : '已处理' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="ctime" label="创建时间" width="160">
                    <template slot-scope="scope">
                        {{ initTime(scope.row.ctime) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="text" style="color: #f82828;" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="codics-aonaer-info-sys-news-pagination" background @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :current-page="searchTxt == '' ? currentPage : searchPage"
                :page-sizes="[10, 20, 50, 100]" :page-size="searchTxt == '' ? dataSize : searchSize"
                layout="total, sizes, prev, pager, next, jumper, slot" :total="searchTxt == '' ? maxSize : searchMax">
            </el-pagination>
        </div>
        
        <!-- 新增客户弹窗 -->
        <MyDialog :visible.sync="addVisible" title="新建客户" :width="'900px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 10px;">
                <MyFormItem label="姓" style="width: calc(33.33% - 10px);">
                    <el-input v-model="addForm.surname" style="width:100%;" autocomplete="off" maxlength="50" size="small"
                        placeholder="请输入姓"></el-input>
                </MyFormItem>
                <MyFormItem label="名" style="width: calc(33.33% - 10px);margin-left:15px;" required>
                    <el-input v-model="addForm.name" style="width:100%;" autocomplete="off" maxlength="50" size="small"
                        placeholder="请输入名"></el-input>
                </MyFormItem>
                <MyFormItem label="电话" style="width: calc(33.33% - 10px);margin-left:15px;" required>
                    <el-input v-model="addForm.phone" style="width:100%;" autocomplete="off" maxlength="20" size="small"
                        placeholder="请输入电话"></el-input>
                </MyFormItem>
                <MyFormItem label="邮箱" style="width: calc(50% - 7.5px);">
                    <el-input v-model="addForm.email" style="width:100%;" autocomplete="off" maxlength="100" size="small"
                        placeholder="请输入邮箱"></el-input>
                </MyFormItem>
                <MyFormItem label="公司" style="width: calc(50% - 7.5px);margin-left:15px;">
                    <el-input v-model="addForm.company" style="width:100%;" autocomplete="off" maxlength="100" size="small"
                        placeholder="请输入公司"></el-input>
                </MyFormItem>
                <MyFormItem label="职位" style="width: calc(33.33% - 10px);">
                    <el-input v-model="addForm.pos" style="width:100%;" autocomplete="off" maxlength="50" size="small"
                        placeholder="请输入职位"></el-input>
                </MyFormItem>
                <MyFormItem label="类型" style="width: calc(33.33% - 10px);margin-left:15px;">
                    <el-input v-model="addForm.type" style="width:100%;" autocomplete="off" maxlength="50" size="small"
                        placeholder="请输入类型"></el-input>
                </MyFormItem>
                <MyFormItem label="地域" style="width: calc(33.33% - 10px);margin-left:15px;">
                    <el-input v-model="addForm.area" style="width:100%;" autocomplete="off" maxlength="50" size="small"
                        placeholder="请输入地域"></el-input>
                </MyFormItem>
                <MyFormItem label="状态" style="width: calc(50% - 7.5px);" required>
                    <el-select v-model="addForm.state" placeholder="请选择状态" style="width:100%;" size="small">
                        <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </MyFormItem>
                <MyFormItem label="内容" style="width: 100%;" required>
                    <el-input v-model="addForm.mess" style="width:100%;" type="textarea" :rows="4" 
                        placeholder="请输入内容" size="small" maxlength="1000" show-word-limit></el-input>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:40px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain
                    @click="addCustomerFuc">确认创建</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="addVisible = false;">取消创建</el-button>
            </div>
        </MyDialog>
        
        <!-- 编辑客户弹窗 -->
        <MyDialog :visible.sync="updateVisible" title="编辑客户" :width="'900px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 10px;">
                <MyFormItem label="姓" style="width: calc(33.33% - 10px);">
                    <el-input v-model="updateForm.surname" style="width:100%;" autocomplete="off" maxlength="50" size="small"
                        placeholder="请输入姓"></el-input>
                </MyFormItem>
                <MyFormItem label="名" style="width: calc(33.33% - 10px);margin-left:15px;" required>
                    <el-input v-model="updateForm.name" style="width:100%;" autocomplete="off" maxlength="50" size="small"
                        placeholder="请输入名"></el-input>
                </MyFormItem>
                <MyFormItem label="电话" style="width: calc(33.33% - 10px);margin-left:15px;" required>
                    <el-input v-model="updateForm.phone" style="width:100%;" autocomplete="off" maxlength="20" size="small"
                        placeholder="请输入电话"></el-input>
                </MyFormItem>
                <MyFormItem label="邮箱" style="width: calc(50% - 7.5px);">
                    <el-input v-model="updateForm.email" style="width:100%;" autocomplete="off" maxlength="100" size="small"
                        placeholder="请输入邮箱"></el-input>
                </MyFormItem>
                <MyFormItem label="公司" style="width: calc(50% - 7.5px);margin-left:15px;">
                    <el-input v-model="updateForm.company" style="width:100%;" autocomplete="off" maxlength="100" size="small"
                        placeholder="请输入公司"></el-input>
                </MyFormItem>
                <MyFormItem label="职位" style="width: calc(33.33% - 10px);">
                    <el-input v-model="updateForm.pos" style="width:100%;" autocomplete="off" maxlength="50" size="small"
                        placeholder="请输入职位"></el-input>
                </MyFormItem>
                <MyFormItem label="类型" style="width: calc(33.33% - 10px);margin-left:15px;">
                    <el-input v-model="updateForm.type" style="width:100%;" autocomplete="off" maxlength="50" size="small"
                        placeholder="请输入类型"></el-input>
                </MyFormItem>
                <MyFormItem label="地域" style="width: calc(33.33% - 10px);margin-left:15px;">
                    <el-input v-model="updateForm.area" style="width:100%;" autocomplete="off" maxlength="50" size="small"
                        placeholder="请输入地域"></el-input>
                </MyFormItem>
                <MyFormItem label="状态" style="width: calc(50% - 7.5px);" required>
                    <el-select v-model="updateForm.state" placeholder="请选择状态" style="width:100%;" size="small">
                        <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </MyFormItem>
                <MyFormItem label="内容" style="width: 100%;" required>
                    <el-input v-model="updateForm.mess" style="width:100%;" type="textarea" :rows="4" 
                        placeholder="请输入内容" size="small" maxlength="1000" show-word-limit></el-input>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:40px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain
                    @click="updateCustomerFuc">确认修改</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="updateVisible = false;">取消修改</el-button>
            </div>
        </MyDialog>
    </div>
</template>

<script>
import MyButton from '@/components/MyButton';
import MyDialog from '@/components/MyDialog';
import MyForm from '@/components/MyForm';
import MyFormItem from '@/components/MyForm/MyFormItem';
import { addCustom, deleteCustom, updateCustom, listCustom } from '@/api';
import { initTime } from '@/utils/myutils';
import * as XLSX from 'xlsx';

export default {
    data() {
        return {
            loading: false,
            addVisible: false,
            updateVisible: false,
            editState: false,
            isCheckAll: false,
            searchTxt: '',
            nowSearchTxt: '',
            currentPage: 1,
            searchPage: 1,
            dataSize: 10,
            searchSize: 10,
            maxSize: 0,
            searchMax: 0,
            nowState: '',
            tableData: [],
            searchData: [],
            selectData: [],
            stateOptions: [
                { value: 0, label: '未处理' },
                { value: 1, label: '已处理' }
            ],
            addForm: {
                surname: '',
                name: '',
                phone: '',
                email: '',
                company: '',
                pos: '',
                type: '',
                area: '',
                mess: '',
                state: 0
            },
            updateForm: {
                id: null,
                surname: '',
                name: '',
                phone: '',
                email: '',
                company: '',
                pos: '',
                type: '',
                area: '',
                mess: '',
                state: 0
            }
        }
    },
    components: {
        MyButton,
        MyDialog,
        MyForm,
        MyFormItem
    },
    mounted() {
        this.listCustomersFuc();
    },
    methods: {
        initTime(date) {
            return initTime(date);
        },
        // 查询客户列表
        async listCustomersFuc() {
            this.loading = true;
            const data = await listCustom({
                key: this.nowSearchTxt,
                pge: this.searchTxt == '' ? this.currentPage : this.searchPage,
                psz: this.searchTxt == '' ? this.dataSize : this.searchSize,
                state: this.nowState === '' ? -1 : this.nowState
            });
            this.loading = false;

            if (data.code == 200) {
                if (this.searchTxt == '') {
                    this.tableData = data.data || [];
                    this.maxSize = data.count || 0;
                } else {
                    this.searchData = data.data || [];
                    this.searchMax = data.count || 0;
                }
            } else {
                if (data.code == 401) return;
                this.$message.error(data.message);
            }
        },
        // 新增客户
        async addCustomerFuc() {
            if (this.addForm.name == '') {
                this.$message.error('名不能为空');
                return;
            }
            if (this.addForm.phone == '') {
                this.$message.error('电话不能为空');
                return;
            }
            if (this.addForm.mess == '') {
                this.$message.error('内容不能为空');
                return;
            }

            const loading = this.$loading({
                lock: true,
                text: '正在添加客户...',
                spinner: 'el-icon-loading',
            });

            const data = await addCustom(this.addForm);
            loading.close();

            if (data.code == 200) {
                this.$message.success('添加成功');
                this.addVisible = false;
                this.resetAddForm();
                this.listCustomersFuc();
            } else {
                this.$message.error(data.message);
            }
        },
        // 编辑客户
        async updateCustomerFuc() {
            if (this.updateForm.name == '') {
                this.$message.error('名不能为空');
                return;
            }
            if (this.updateForm.phone == '') {
                this.$message.error('电话不能为空');
                return;
            }
            if (this.updateForm.mess == '') {
                this.$message.error('内容不能为空');
                return;
            }

            const loading = this.$loading({
                lock: true,
                text: '正在修改客户...',
                spinner: 'el-icon-loading',
            });

            const data = await updateCustom(this.updateForm);
            loading.close();

            if (data.code == 200) {
                this.$message.success('修改成功');
                this.updateVisible = false;
                this.listCustomersFuc();
            } else {
                this.$message.error(data.message);
            }
        },
        // 删除客户
        async deleteCustomersFuc(t) {
            if (t == null) {
                t = [];
                this.selectData.forEach(item => {
                    t[t.length] = item.id;
                });
                if (t.length == 0) {
                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });
                    return true;
                }
            }

            const loading = this.$loading({
                lock: true,
                text: '正在删除客户...',
                spinner: 'el-icon-loading',
            });

            const data = await deleteCustom({ ids: t });
            loading.close();

            if (data.code == 200) {
                this.$message.success('删除成功');
                this.listCustomersFuc();
            } else {
                this.$message.error(data.message);
            }
        },
        // 导出Excel
        exportToExcel() {
            if (this.selectData.length === 0) {
                this.$message.warning('请先选择要导出的数据');
                return;
            }

            const exportData = this.selectData.map(item => ({
                'ID': item.id,
                '姓': item.surname || '',
                '名': item.name || '',
                '邮箱': item.email || '',
                '电话': item.phone || '',
                '公司': item.company || '',
                '职位': item.pos || '',
                '类型': item.type || '',
                '地域': item.area || '',
                '内容': item.mess || '',
                '状态': item.state === 0 ? '未处理' : '已处理',
                '创建时间': item.ctime ? this.initTime(item.ctime) : ''
            }));

            const ws = XLSX.utils.json_to_sheet(exportData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '客户信息');

            // 生成文件名：独立站客户_xxxx年xx月xx日.xlsx
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const fileName = `独立站客户_${year}年${month}月${day}日.xlsx`;

            XLSX.writeFile(wb, fileName);
            this.$message.success(`成功导出 ${this.selectData.length} 条客户信息`);
        },
        // 编辑按钮点击
        handleEdit(row) {
            this.updateForm = { ...row };
            this.updateVisible = true;
        },
        // 删除按钮点击
        handleDelete(row) {
            this.$confirm('确认要删除该客户吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteCustomersFuc([row.id]);
            }).catch(() => {});
        },
        // 批量编辑切换
        handleCheckClick() {
            this.editState = !this.editState;
            if (!this.editState) {
                this.tableData.forEach(item => {
                    item.checked = false;
                });
                this.searchData.forEach(item => {
                    item.checked = false;
                });
                this.selectData = [];
            }
        },
        // 全选
        checkAll() {
            this.isCheckAll = !this.isCheckAll;
            const data = this.searchTxt ? this.searchData : this.tableData;
            data.forEach(item => {
                item.checked = !this.isCheckAll;
            });
            this.$refs.table.toggleAllSelection();
        },
        // 表格选择变化
        handleSelectionChange(val) {
            this.selectData = val;
        },
        // 分页大小变化
        handleSizeChange(val) {
            if (this.searchTxt == '') {
                this.dataSize = val;
            } else {
                this.searchSize = val;
            }
            this.listCustomersFuc();
        },
        // 页码变化
        handleCurrentChange(val) {
            if (this.searchTxt == '') {
                this.currentPage = val;
            } else {
                this.searchPage = val;
            }
            this.listCustomersFuc();
        },
        // 搜索输入变化
        searchChange(a) {
            if (a == '') {
                this.searchPage = 1;
                this.searchData = [];
                this.searchMax = 0;
                this.searchSize = 10;
                this.nowSearchTxt = '';
            }
        },
        // 搜索确认
        handleSearchChange() {
            this.searchPage = 1;
            this.searchData = [];
            this.nowSearchTxt = this.searchTxt;
            this.listCustomersFuc();
        },
        // 重置新增表单
        resetAddForm() {
            this.addForm = {
                surname: '',
                name: '',
                phone: '',
                email: '',
                company: '',
                pos: '',
                type: '',
                area: '',
                mess: '',
                state: 0
            };
        }
    }
}
</script>

<style>
.com-codics-book-admin-feedback-body {
    height: calc(100vh - 50px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: auto;
}

:root {
    --el-input-bg-color: #FFF;
    --el-input-l-color: #DCDFE6;
    --el-input-l-hover-color: #C0C4CC;
    --el-input-l-focus-color: #000;
    --el-table-bg-color: #FFF;
    --el-table-l-color: #EBEEF5;
    --el-table-bg-hover-color: #F5F7FA;
    --el-table-body-font-color: #606266;
    --el-table-page-bg-color: #FFF;
    --el-table-page-bg-active-color: #333;
    --el-table-page-font-color: #606266;
    --el-table-page-font-active-color: #FFF;
}

:root[data-theme="dark"] {
    --el-input-bg-color: #333;
    --el-input-l-color: #444;
    --el-input-l-hover-color: #555;
    --el-input-l-focus-color: #888;
    --el-table-bg-color: #333;
    --el-table-l-color: #444;
    --el-table-bg-hover-color: #555;
    --el-table-body-font-color: #999;
    --el-table-page-bg-color: #292B2C;
    --el-table-page-bg-active-color: #FFF;
    --el-table-page-font-color: #AAA;
    --el-table-page-font-active-color: #333;
}

.el-input__inner {
    background-color: var(--el-input-bg-color) !important;
    border-color: var(--el-input-l-color) !important;
}

.el-input__inner:hover {
    border-color: var(--el-input-l-hover-color) !important;
}

.el-input__inner:focus {
    border-color: var(--el-input-l-focus-color) !important;
}

.el-table th.el-table__cell {
    background-color: var(--el-table-bg-color) !important;
}

.el-table tr {
    background-color: var(--el-table-bg-color) !important;
}

.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid var(--el-table-l-color) !important;
}

.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background-color: var(--el-table-bg-hover-color) !important;
}

.el-table--border::after,
.el-table--group::after,
.el-table::before {
    background-color: var(--el-table-l-color) !important;
}

.el-table {
    color: var(--el-table-body-font-color) !important;
}

.el-table,
.el-table__expanded-cell {
    background: var(--el-table-bg-color) !important;
}

.com-codics-book-admin-feedback-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 15px;
    transition: .3s;
}

.com-codics-book-admin-feedback-bar-content2 {
    box-sizing: border-box;
    padding: 20px;
}

.com-codics-book-admin-feedback-bar-pick {
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-right: 15px;
    width: 150px;
}

.com-codics-book-admin-feedback-bar-input {
    width: 220px !important;
    position: relative;
    float: right;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-news-pagination {
    height: fit-content;
    position: relative;
    float: left;
    margin-top: 20px;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background-color: var(--el-table-page-bg-color) !important;
    color: var(--el-table-page-font-color) !important;
}

.el-pagination.is-background .el-pager .active {
    background-color: var(--el-table-page-bg-active-color) !important;
    color: var(--el-table-page-font-active-color) !important;
}
</style>
